import * as React from 'react'

import DesktopInitialState from '~/client/src/desktop/stores/DesktopInitialState'

import ResourceControlsContent from './ResourceControlsContent'
import { IResourceControlsConfig } from './types'

interface IProps {
  config: IResourceControlsConfig
  projectId: string
  userId: string
  state: DesktopInitialState
}

/**
 * Resource-agnostic Controls view. Wraps the config's resource provider,
 * renders the shared Controls content, and mounts the resource's edit panel as
 * a sibling (opened on row select). Consumers (EquipmentControls,
 * MaterialResourcesControls, ...) supply an `IResourceControlsConfig` and the
 * runtime identity (projectId/userId/state), guarding for their presence first.
 */
function ResourceControlsView({ config, projectId, userId, state }: IProps) {
  const { ProviderComponent, editPanel } = config

  return (
    <div className="tw:flex tw:h-full tw:flex-col">
      <ProviderComponent projectId={projectId} userId={userId} state={state}>
        <ResourceControlsContent
          projectId={projectId}
          userId={userId}
          config={config}
        />
        {editPanel}
      </ProviderComponent>
    </div>
  )
}

export default ResourceControlsView
